var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#233737",
    fillOpacity: 0.05
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3485_17878)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3877 14.2268C19.0306 14.4367 18.5709 14.3173 18.3611 13.9601L17.8814 13.1437C17.7615 13.2478 17.6162 13.3355 17.4438 13.4025L13.8592 14.7968L15.7138 16.4158C16.4247 17.0364 16.5155 18.1089 15.919 18.8402L15.0641 19.8884C14.445 20.6473 13.3237 20.7505 12.5765 20.1173L8.6772 16.8124L7.07136 17.437C6.26636 17.7501 5.35332 17.429 4.92144 16.681L3.77936 14.7029C3.34749 13.9548 3.52597 13.0036 4.19963 12.463L12.8798 5.4974C13.0001 5.4008 13.1187 5.31282 13.235 5.23576L12.7322 4.38006C12.5224 4.02293 12.6418 3.56332 12.9989 3.35348C13.356 3.14364 13.8156 3.26305 14.0255 3.62018L19.6544 13.2003C19.8642 13.5574 19.7448 14.017 19.3877 14.2268ZM17.0578 11.7419L14.0506 6.62396C13.9742 6.59979 13.887 6.61238 13.8186 6.66729L7.87474 11.4371C7.9343 11.4895 7.98648 11.5524 8.02837 11.625L9.83424 14.7529L16.9 12.0046C17.0101 11.9618 17.0708 11.8512 17.0578 11.7419ZM8.41982 15.303L6.72933 12.375C6.72685 12.3707 6.72442 12.3664 6.72204 12.3621L5.13844 13.6329C5.0422 13.7101 5.0167 13.846 5.0784 13.9529L6.22048 15.931C6.28218 16.0379 6.41261 16.0837 6.52761 16.039L8.41982 15.303ZM12.2813 15.4105L10.2674 16.1939L13.5464 18.973C13.6531 19.0634 13.8133 19.0487 13.9017 18.9403L14.7567 17.8921C14.8419 17.7877 14.8289 17.6344 14.7273 17.5458L12.2813 15.4105Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3485_17878"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAd);
export default __webpack_public_path__ + "static/media/ad.5f6d4b6bc23915b5f7978f86b442f7b2.svg";
export { ForwardRef as ReactComponent };